import React from 'react'
import { CookiesProvider } from 'react-cookie'
import { AuthProvider } from './utils/context/AuthContext'
import { CookieConsentPopUpWrapper } from './components/CookieConsentPopUp'
import SearchContext from './components/Search/SearchContext'
import GatedContentHandler from './utils/GatedContentHandler'

const wrapRootElement = (props) => {
  return (
    <>
      <AuthProvider>
        <CookiesProvider>
          <SearchContext.GoogleProvider>
            <GatedContentHandler>{props.element}</GatedContentHandler>
          </SearchContext.GoogleProvider>
        </CookiesProvider>
      </AuthProvider>
      <CookieConsentPopUpWrapper />
    </>
  )
}
export default wrapRootElement
